import React from 'react';
import { Button } from './ui/Button';
import { Lock, ArrowRight, CreditCard } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-20 bg-gradient-to-br from-orange-500 to-pink-600 px-4 text-center" data-id="element-173">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-174">
        <div className="inline-block px-4 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm font-bold mb-6" data-id="element-175">
          🔥 60% DE DESCUENTO
        </div>

        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-176">
          Inglés Sin Pena (7 días)
        </h2>
        <p className="text-xl text-gray-600 mb-8" data-id="element-177">
          El kit completo de guiones + audios + plan de acción
        </p>

        <div className="flex flex-col items-center justify-center mb-8" data-id="element-178">
          <span className="text-xl text-gray-400 line-through mb-1" data-id="element-179">
            $29.90
          </span>
          <div className="flex items-center gap-3" data-id="element-180">
            <span className="text-6xl font-black text-gray-900 tracking-tight" data-id="element-181">
              $11.96
            </span>
            <span className="bg-red-500 text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-182">
              -60%
            </span>
          </div>
          <span className="text-xl text-gray-500 mt-1" data-id="element-183">pago único</span>
        </div>

        <Button size="lg" fullWidth className="text-xl py-8 mb-6 shadow-xl hover:shadow-2xl hover:-translate-y-1 transition-all" onClick={() => window.open('https://www.paginaspro.com/cart/52277939798295:1', '_blank')} data-id="element-184">
          Descargar Ahora
          <ArrowRight className="ml-2 h-6 w-6" data-id="element-185" />
        </Button>

        <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-sm text-gray-500" data-id="element-186">
          <div className="flex items-center" data-id="element-187">
            <Lock className="w-4 h-4 mr-2" data-id="element-188" />
            Pago 100% Seguro
          </div>
          <div className="hidden md:block" data-id="element-189">•</div>
          <div className="flex items-center" data-id="element-190">
            <CreditCard className="w-4 h-4 mr-2" data-id="element-191" />
            Acceso Inmediato al PDF
          </div>
        </div>
      </div>
    </section>;
}